export default "__VITE_ASSET__CgygYM5m__"